var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonCookies = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M39.74 24.006a4.416 4.416 0 01-1.16-2.047 6.627 6.627 0 01-5.888-1.837 6.617 6.617 0 01-1.73-3.02 6.593 6.593 0 01-3.023-1.732 6.64 6.64 0 01-1.84-5.886A4.444 4.444 0 0122.916 4 19.944 19.944 0 009.865 9.83c-7.819 7.818-7.819 20.492 0 28.31 7.818 7.818 20.492 7.818 28.31 0a19.942 19.942 0 005.825-12.973 4.452 4.452 0 01-4.259-1.16z", fill: fills.light }),
        React.createElement("path", { d: "M34.752 32.253a1.825 1.825 0 100-3.65 1.825 1.825 0 000 3.65z", fill: fills.base }),
        React.createElement("path", { d: "M39.603 14.335a1.417 1.417 0 100-2.835 1.417 1.417 0 000 2.835zM41.417 7.834a1.417 1.417 0 100-2.834 1.417 1.417 0 000 2.834zM32.908 12.252a1.566 1.566 0 100-3.133 1.566 1.566 0 000 3.133z", fill: fills.light }),
        React.createElement("path", { d: "M22.128 38.204a1.825 1.825 0 100-3.65 1.825 1.825 0 000 3.65zM24.796 23.615a1.825 1.825 0 100-3.65 1.825 1.825 0 000 3.65z", fill: fills.dark }),
        React.createElement("path", { d: "M15.355 16.2a1.825 1.825 0 100-3.65 1.825 1.825 0 000 3.65zM13.587 29.241a1.825 1.825 0 100-3.65 1.825 1.825 0 000 3.65z", fill: fills.base })));
}, {
    name: identiconComponentName,
})({});
